<template>
  <div>
    <div
      class="tw-flex tw-flex-col tw-mx-auto"
      style="max-width: 768px"
    >
      <h2 class="question-title-v2 tw-mb-6 tw-text-white">
        {{ question.question }}
      </h2>
      <div class="tw-mb-2">
        <w-checkbox
          v-for="(item, i) in question.answerlist"
          :id="item.name + question.id"
          :key="item.name + i"
          v-model="answer"
          :value="item.id"
          type="radio"
          :label="item.name"
          :is-cancel="true"
          @change="onChange(item.id, item)"
        />
        <div class="tw-text-center">
          <b-button
            v-if="hasAnswer"
            class="tw-mt-6"
            variant="info"
            size="lg"
            style="width: 100%"
            @click="onContinue"
          >
            Continue
          </b-button>
        </div>
      </div>
      <div class="cancel-membership">
        <div class="tw-mt-4 tw-pt-1">
          <a
            href="javascript:void(0)"
            class="text-underline text-uppercase tw-text-white"
            style="letter-spacing: 0.1rem"
          >
            Cancel membership
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: { type: Object, required: true },
  },
  data() {
    return { answer: null };
  },
  computed: {
    hasAnswer() {
      return Object.prototype.hasOwnProperty.call(this.question, 'answer');
    },
  },
  watch: {
    question: {
      handler() {
        this.answer = this.question.answer ?? null;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onChange(id, item) {
      this.$emit('submitAnswer', { id: this.question.id, answer: id, answerBody: item });
    },
    onContinue() {
      const item = this.question.answerlist.find(o => o.id == this.answer);
      this.$emit('submitAnswer', { id: this.question.id, answer: this.answer, answerBody: item });
    },
  },
};
</script>

<style scoped>
.cancel-membership {
  display: flex;
  flex-direction: column;
  max-width: 250px;
  align-items: center;
}
</style>
